import UserDetailView from './UserDetailView';
import UserTable from './UserTable';
import UIFetchService from '../Service/UIFetchService';
import auth from '../Service/AuthFetchService';

import { Button, Input, Breadcrumb, Space, Row, Col,Checkbox } from 'antd';
import { BrowserRouter as Router, Link, Route, Switch } from 'react-router-dom';
import React from 'react';
import { isNotEmpty } from '../Service/Utils';


class UserQueryingView extends React.Component {
    confKey = 'user.collect.cfg';
    constructor() {
        super();
        const rawConf = localStorage.getItem(this.confKey);
        let cfg = {
            collectOnly: false,
        };
        if (isNotEmpty(rawConf)) {
            cfg = JSON.parse(rawConf);
        }

        this.state = {
            pageNo: 1,
            pageSize: 12,
            searchKey: '',
            showDetail: false,
            bczUid: 0,
            users: [],
            ...cfg
        }
    }

    componentDidMount() {
        this.fetchPaginationUsers(this.state.pageNo, this.state.pageSize, '');
        auth.appendLog('单用户查询');
    }

    async fetchPaginationUsers(pageNo, pageSize, searchKey, collectOnly) {
        if(collectOnly === undefined){
            collectOnly = this.state.collectOnly
        }
        this.saveCfg(collectOnly);
        const url = '/api/v1/user_profile/users/summary?pageNo=' + pageNo
            + '&pageSize=' + pageSize
            + '&searchKey=' + encodeURI(searchKey)
            + '&collectOnly=' + collectOnly

        const users = await UIFetchService.get(url);
        this.setState({users: users, pageNo: pageNo, searchKey: searchKey, collectOnly: collectOnly});
    }

    userTableDidChanged = async (event) => {
        this.fetchPaginationUsers(this.state.pageNo, this.state.pageSize, event.target.value);
    }

    firstPageDidClicked = async () => {
        const pageNo = 1;
        this.fetchPaginationUsers(pageNo, this.state.pageSize, '');
    }

    prevPageDidClicked = async () => {
        const pageNo = this.state.pageNo <= 1 ? 1 : this.state.pageNo - 1;
        this.fetchPaginationUsers(pageNo, this.state.pageSize, '');
    }

    nextPageDidClicked = async () => {
        const pageNo = this.state.pageNo + 1;
        this.fetchPaginationUsers(pageNo, this.state.pageSize, '');
    }

    saveCfg(collectOnly) {
        const cfg = { collectOnly: collectOnly};
        localStorage.setItem(this.confKey, JSON.stringify(cfg));
    }

    // 86863825
    renderList() {
        return <>
            <Row>
                <Col span={4}>
                    <Input.Search
                        allowClear
                        onChange={this.userTableDidChanged} />
                </Col>
                <Col style={{ alignSelf: 'center', margin: '0 0 0 10px' }}>
                    <Checkbox
                        checked={this.state.collectOnly}
                        onChange={({ target: { checked } }) => {
                            this.fetchPaginationUsers(this.state.pageNo, this.state.pageSize, this.state.searchKey, checked)
                        }}
                    >我的收藏</Checkbox>
                </Col>
            </Row>
            <div style={{ height: '10px' }} />
            <Row>
                <Col flex="100%">
                    <UserTable
                        dataSource={this.state.users}
                        onShowDetail={(bczUid) => window.open(`/user_profile/users/${bczUid}`)}
                        isShowOper={true}
                        pagination={false}
                        refreshTable={() => this.fetchPaginationUsers(this.state.pageNo, this.state.pageSize, this.state.searchKey)}
                    />
                </Col>
            </Row>
            <div style={{ height: '10px' }} />
            <Row>
                <Col flex="auto" />
                <Col flex="200px">
                    {this.state.searchKey === '' &&
                        <Space>
                            <Button onClick={this.firstPageDidClicked}>{'回到<1>页'}</Button>
                            <Button onClick={this.prevPageDidClicked}>{"<"}</Button>
                            <span>{this.state.pageNo}</span>
                            <Button onClick={this.nextPageDidClicked}>{">"}</Button>
                        </Space>}
                </Col>
                <Col flex="auto" />
            </Row>
        </>
    }

    render() {
        const navigator = <Breadcrumb>
            <Breadcrumb.Item>个体洞察</Breadcrumb.Item>
            <Breadcrumb.Item>
                <Link to="/" >用户列表</Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item>用户详情</Breadcrumb.Item>
        </Breadcrumb>;

        return <Router basename="/user_profile/users">
            <Switch>
                <Route path="/" exact render={() => this.renderList()} />
                <Route path="/:id" render={(history) => <UserDetailView navigator={navigator} bczUid={history.match.params.id} />} />
            </Switch>
        </Router>
    }
}

export default UserQueryingView;